import React, { useEffect, useState } from "react";
import { Popover } from "@mui/material";
import { FeatureService } from "../../services/FeatureService";
import { UtilityService } from "../../services/UtilityService";
import ConfirmDialog from "../shared/confirm-dialog.component";
import { appNote, emptyLabels, pageTitles, ToasterTexts, typeLabels, } from "../shared/constants";
import { LoadFeatures } from "../../actions/index";
import { FeaturesModel } from "../../models/features.model";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import PullToRefresh from "react-simple-pull-to-refresh";
import { CustomFilterCategory } from "../shared/filters/filter.model";
import CustomSwitch from "../shared/switch.component";
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import PageHeaderComponent from '../shared/page-header.component';
import GridComponent from "../shared/grid";
import { ColDef, ValueGetterParams, ICellRendererParams, ColumnApi } from 'ag-grid-community';
import { HeaderTemplate } from "../shared/grid/grid.services";
import _ from 'lodash';
import FilterComponent from "../shared/filters/filter.component";
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

interface IProps {
}

const Features = (props: IProps) => {
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const Feature: FeaturesModel[] = useSelector(selector.features)
    const LoadingFeatures: boolean = useSelector(selector.loadingFeatures)
    const [gridApi, setGridApi] = useState<any>()
    const [ShowFilters, setShowFilters] = useState<boolean>(false)
    const [anchorEl, setAnchoeEl] = useState<Element>(null)
    const [Show, setShow] = useState<boolean>(false);
    const [featureId, setfeatureId] = useState<string>("");
    const [Text, setText] = useState<string>("");
    const [ButtonName, setButtonName] = useState<string>("");
    const [IsLoading, setIsLoading] = useState<boolean>(false);
    const [MobileMenu, setMobileMenu] = useState<boolean>(false);
    const [columnApi, setColumnApi] = useState<ColumnApi>(null);
    const [filterPopUp, setFilterPopUp] = useState<boolean>(false)
    const [filterOptions, setFilterOptions] = useState<any[]>([]);
    const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);

    const onSearch = (e: any) => {
        gridApi?.setQuickFilter(e.target.value)
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        setColumnApi(params.columnApi)
    }

    useEffect(() => {
        if (Feature?.length === 0 && !LoadingFeatures) {
            refreshData();
        }
    }, []);

    useEffect(() => {
        setHeaderTitle(pageTitles.FEATURES);
        setHeaderCount(Feature?.length || 0)
        setRefreshHandler(gridRefresh)
        return setHeaderTitle
    }, [gridApi, columnApi])

    const gridRefresh = () => {
        resetFilters()
        refreshData();
        if (!!columnApi) {
            columnApi?.resetColumnState()
        }
        if (!!gridApi) {
            gridApi?.refreshCells({ force: true })
        }
        gridApi?.deselectAll();
    }

    const refreshData = () => {
        LoadFeatures(dispatch);
    };

    const closeConfirmDialog = (isConfirm: boolean) => {
        if (!!isConfirm) {
            setIsLoading(true);
            let row = Feature?.filter(
                (x: any) => x.ID === featureId
            )[0];
            FeatureService.DisableFeature(featureId).then((res) => {
                resetFilters()
                setShow(false);
                setButtonName("");
                setfeatureId("");
                setToast(
                    !row.IsDeleted
                        ? ToasterTexts.FEATURE_DISABLE_SUCCESS.replace("<Name>", row.Name)
                        : ToasterTexts.FEATURE_ENABLE_SUCCESS.replace("<Name>", row.Name),
                    ToasterType.SUCCESS
                );
                refreshData();
            });
        } else {
            setShow(false);
            setButtonName("");
            setIsLoading(false);
        }
    };

    const openDisableDialog = (id: string) => {
        let row = Feature?.filter((x: any) => x.ID === id)[0];
        let text = row.IsDeleted ? appNote.ENABLE_FEATURE : appNote.DISABLE_FEATURE;
        setShow(true);
        setfeatureId(id);
        setText(text);
        setButtonName(row.IsDeleted ? "Enable" : "Disable");
        setIsLoading(false);
    };

    const pullToRefresh = () =>
        new Promise((resolve) => setTimeout(resolve, 15)).then(() =>
            refreshData()
        );

    const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        setFilterPopUp(!filterPopUp)
        setAnchoeEl(event.currentTarget)
    }
    const handleCloseFilter = () => {
        setFilterPopUp(false)
        setAnchoeEl(null)
    }

    const getGridTitle = () => {
        if (Feature?.length === 1) {
            return "1 Feature"
        }
        else {
            return Feature?.length + " " + pageTitles.FEATURES
        }
    }

    let FeaturesColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Feature Name",
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "Type",
            headerName: "Type",
            headerComponentParams: {
                template: selectedFilterTypes.includes("Type") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Type === 0 ? typeLabels.TYPE_ZERO : params.data.Type === 1 ? typeLabels.TYPE_ONE : typeLabels.TYPE_TWO
            },
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "Label",
            headerName: "Label",
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
            hide: IsMobileDevice,
        },
        {
            field: "CreatedDateTime",
            headerName: "Updated Date",
            hide: IsMobileDevice,
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertDateToDay(params.data.CreatedDateTime)
            },
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },

        {
            field: "IsDeleted",
            headerName: "",
            headerComponentParams: {
                template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            cellRenderer: (params: ICellRendererParams) => <CustomSwitch
                checked={!params.data.IsDeleted}
                onChange={() => openDisableDialog(params.data.ID)}

            />
        },
    ]
    const handleRowClick = (row: FeaturesModel) => {
        if (IsMobileDevice) {
            setMobileMenu(true);
        }
    }


    // ********************filter code********************
    const initialFilterOptions = () => {
        const filterData: any[] = [
            {
                Id: 1,
                Title: "Type",
                IsSelectedAll: false,
                Options: _(Feature)
                    .map(row => ({
                        Key: "Type",
                        Id: row.ID,
                        Label: row.Type === 0 ? typeLabels.TYPE_ZERO : row.Type === 1 ? typeLabels.TYPE_ONE : typeLabels.TYPE_TWO,
                        Value: row.Type,
                        IsSelected: false,
                    }))
                    .uniqBy('Label')
                    .value()
            },
            {
                Id: 2,
                Title: "Status",
                IsSelectedAll: false,
                Options: _(Feature)
                    .map(row => ({
                        Key: "IsDeleted",
                        Id: row.ID,
                        Label: row.IsDeleted === true ? "Disable" : "Enable",
                        Value: row.IsDeleted,
                        IsSelected: false,
                    }))
                    .uniqBy('Label')
                    .value()
            }
        ]
        setFilterOptions(filterData)
    }

    const handleApplyFilters = (filters: CustomFilterCategory[]) => {
        setFilterOptions(filters);
        const { result } = UtilityService.getFilterTypes(filters);
        setSelectedFilterTypes(result)

    };

    useEffect(() => {
        initialFilterOptions()
        setHeaderCount(Feature?.length || 0)
    }, [Feature])

    const resetFilters = () => {
        setFilterOptions([])
        setSelectedFilterTypes([])
        initialFilterOptions()
    }
    //---*----filters---*----

    return (
        (ShowFilters && IsMobileDevice) ?
            <FilterComponent
                Filters={filterOptions}
                OnClose={handleCloseFilter}
                HandleApplyFilters={handleApplyFilters}
            />
            :
            <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                <PullToRefresh isPullable={IsMobileDevice} pullingContent="" onRefresh={pullToRefresh} >
                    <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                        <PageHeaderComponent
                            GridTitle={""}
                            Count={Feature.length}
                            HandleFilter={handleClickFilter}
                            ShowFilterIcon={true}
                            IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
                            onSearch={onSearch}
                            PlaceHolder={"Find a Feature..."}
                        />
                        <GridComponent
                            ColumnDefs={FeaturesColoumnDefs}
                            RowData={Feature}
                            OnGridReady={onGridReady}
                            IsPaginationEnabled={IsMobileDevice ? false : true}
                            EmptyLabel={emptyLabels.FEATURES}
                            LockVisible={IsMobileDevice}
                            OnGridRowClick={handleRowClick}
                            filterOptions={filterOptions}
                            IsFilterPresent={true}
                            gridApi={gridApi}
                        />

                        {filterPopUp &&
                            <Popover
                                open={!!anchorEl}
                                anchorEl={anchorEl}
                                onClose={handleCloseFilter}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                classes={{ paper: "min-h-40" }}
                            // BackdropProps={{
                            //     invisible: true,
                            //     onClick: (event) => event.stopPropagation(),
                            // }}
                            >
                                <FilterComponent
                                    Filters={filterOptions}
                                    OnClose={handleCloseFilter}
                                    HandleApplyFilters={handleApplyFilters}
                                />
                            </Popover>
                        }

                        <ConfirmDialog
                            ButtonName={ButtonName}
                            onClose={closeConfirmDialog}
                            Show={Show}
                            Text={Text}
                            Loading={IsLoading}
                        ></ConfirmDialog>

                    </div>
                </PullToRefresh>
            </div>
    )
};

export default Features
